import { CartaoContasService } from '../../../../shared/components/cartao-gestante/cartao-contas.service';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { WebviewService } from '../../webview.service';
import { AlertsService } from 'app/shared/alerts.service';
import { CartaoGestante, ExameLaboratorio, Paciente } from 'app/core/interfaces/pacient-info.interface';
import { FormGroup, FormControl } from '@angular/forms';
import { ModalsService } from 'app/shared/modals.service';
import { Enfermeiro } from 'app/core/interfaces/enfermeiro.interface';
import { MatDialog } from '@angular/material';
import { ModalAdicionarExameComponent } from '../../components/modal-adicionar-exame/modal-adicionar-exame.component';
import { Events } from 'app/core/events';
import { WebviewEncerrarCartaoComponent } from '../webview-encerrar-cartao/webview-encerrar-cartao.component';
import { APIGestaCardService } from 'app/core/api/gestacard.service';
import { RolesManagerService } from 'app/core/guards/roles-manager.service';
import { Medico } from 'app/core/interfaces/medico.interface';
import { Acesso } from 'app/core/interfaces/acesso.interface';
import { logger } from '../../../../core/utils/console';
import { LaboratorioArquivoFlowService } from 'app/shared/laboratorio-arquivo-flow.service';

@Component({
    selector: 'app-webview-cartao-gestante',
    templateUrl: './webview-cartao-gestante.component.html',
    styleUrls: ['./webview-cartao-gestante.component.scss']
})
export class WebviewCartaoGestanteComponent implements OnInit, AfterViewInit {

  fuseConfig: any;
  viewEdit = false;

  acesso: Acesso;
  usuarioLogado: Paciente | Enfermeiro | Medico;
  profissional: Enfermeiro | Medico;
  paciente: Paciente;
  cartao: CartaoGestante = null;

  examesLabArr = ['ABO/Rh', 'Hepatite B', 'Hepatite C', 'Plaquetas', 'HT/HB', 'CMV IgG', 'CMV IgM', 'TSH', 'Glicose em Jejum', 'TTOG (GTT)', 'HIV', 'VDRL', 'HBsAG', 'Coombs Ind', 'Toxo IgM', 'Toxo IgG', 'Rubéola IgM', 'Rubéola IgG', 'Urina I', 'Urocultura', 'Parasitológico', 'Cultura Streptococcus', 'Parasitológico', 'Outros'];

  loading = true;
  showCard = false;

  dados_graficos_prontos = false;
  dados_dos_graficos: any = [];

  @ViewChild('cartao_gestante_componente') componente_cartao_gestante: any = null;

  form_info_cartao: FormGroup = new FormGroup({
      data_concepcao: new FormControl(''),
      previsao_parto_dum: new FormControl(''),
      previsao_parto_ultrassom: new FormControl(''),
  });
  formulario_cartao_gestante: FormGroup;
  formulario_cartao_alterado: boolean;

  timeoutInitCartaoEvents;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private webviewService: WebviewService, 
    private snackService: AlertsService, 
    private modalService: ModalsService, 
    private matDialog: MatDialog,
    private events:Events,
    private _apigestacard: APIGestaCardService,  // apagar
    private _rolesManagerService: RolesManagerService,
    public cartaoService: CartaoContasService,
    private _laboratorioArquivoFlow: LaboratorioArquivoFlowService,
  ) {
  }

  ngOnInit() {

    this.initCartaoEvents()

    this.initData();

  }

  ngAfterViewInit() {
    
  }

  initCartaoEvents() {
    // Buscando o formulário do componente cartão gestante
    this.events.unsubscribe('CarregarExames'); // EXAMES LABORATORIAIS
    this.events.subscribe('CarregarExames', () => {

      const aux = this.cartao.sobre_a_gestacao;
      const DppUS = this.cartaoService.PrevisaoUltrassom(aux.us1, aux.us_semanas, aux.us_dias);

      const trimestres = this.cartaoService.CalcularTrimestres(DppUS);

      const vetor_exames = this.examesLabArr.map((item) => {
        return {
          name: item,
          data_limite_tri1: '',
          data_limite_tri2: '',
          data_limite_tri3: '',
          arquivo_res1: null,
          arquivo_res2: null,
          arquivo_res3: null,
          datas: {
              data1: trimestres[0] ? trimestres[0] : '',
              data2: trimestres[1] ? trimestres[1] : '',
              data3: trimestres[2] ? trimestres[2] : '',
              res1: '',
              res2: '',
              res3: '',
          }
        };
      });

      this._apigestacard.InserirLab(this.cartao.id, vetor_exames, this.cartao.exames).then((result) => {
        
        this.InserirExameRefresh();

      }).catch((err) => {

        logger.log('WebviewCartaoGestanteComponent -> InserirLab -> err', err);

      });

    }); // end event CarregarExames
    
    this.events.unsubscribe('AbrirArquivoAnalisado'); // Evitando Loop de subscribe ao sair e voltar no componente
    this.events.subscribe('AbrirArquivoAnalisado', (arquivo_id: string) => {
      this.AbrirArquivoAnalisado(arquivo_id);
    });

    this.events.unsubscribe('ExameLaboratorialIncluirPDF'); // Evitando Loop de subscribe ao sair e voltar no componente
    this.events.subscribe('ExameLaboratorialIncluirPDF', data => {
      this.AnalisarPDFExamesLab(data);
    });

    this.events.unsubscribe('UtilizarArquivoLaboratorial'); // Evitando Loop de subscribe ao sair e voltar no componente
    this.events.subscribe('UtilizarArquivoLaboratorial', data => {
      this.UtilizarArquivoLabExistente(data);
    });

    this.events.unsubscribe('AnalisarArquivoLaboratorial');
    this.events.subscribe('AnalisarArquivoLaboratorial', data => {
      this.AnalisarArquivoLabExistente(data);
    });

    this.events.unsubscribe('ExameUltrassonografiaIncluir'); // Evitando Loop de subscribe ao sair e voltar no componente
    this.events.subscribe('ExameUltrassonografiaIncluir', data => {
      this.InserirUSG();
    });

    this.events.unsubscribe('ExameUltrassonografiaRemover');
    this.events.subscribe('ExameUltrassonografiaRemover', data => {
      this.RemoverExameUSG(data);
    });
    
    this.events.unsubscribe('ExameUltrassonografiaIncluirPDF'); // Evitando Loop de subscribe ao sair e voltar no componente
    this.events.subscribe('ExameUltrassonografiaIncluirPDF', data => {
      this.AlterarListaUSG();
    });

    this.events.unsubscribe('UtilizarArquivoUSG'); // Evitando Loop de subscribe ao sair e voltar no componente
    this.events.subscribe('UtilizarArquivoUSG', data => {
      this.UtilizarArquivoUSGExistente(data);
    });

    this.events.unsubscribe('AnalisarArquivoUSG');
    this.events.subscribe('AnalisarArquivoUSG', data => {
      this.AnalisarArquivoUSGExistente(data);
    });

    this.events.unsubscribe('ExameOutrosIncluir'); // Evitando Loop de subscribe ao sair e voltar no componente
    this.events.subscribe('ExameOutrosIncluir', data => {
      
      this.InserirOutro();

    });

    this.events.unsubscribe('ExameClinicoIncluir'); // Evitando Loop de subscribe ao sair e voltar no componente
    this.events.subscribe('ExameClinicoIncluir', data => {
      
      this.InserirClinico();

    });

    this.events.unsubscribe('ExameClinicoAddObservacao'); // Evitando Loop de subscribe ao sair e voltar no componente
    this.events.subscribe('ExameClinicoAddObservacao', data => {
      
      this.ExameClinicoAddObservacao(data);

    });

    this.events.unsubscribe('ExameClinicoEditar'); // Evitando Loop de subscribe ao sair e voltar no componente
    this.events.subscribe('ExameClinicoEditar', data => {
      
      this.EditarClinico(data);

    });

    this.formulario_cartao_alterado = false;
  }

  async initMenu() {
    const setando_ambiente = await this._rolesManagerService.SetarAmbiente('webview');

    if (setando_ambiente != 'sucesso') {
      this.snackService.SnackMessage('Usuário sem permissão de acesso ao sistema');
      this.router.navigate(['/auth/login']);
    }
  }

  async initAcesso() {
    this.acesso = await this.webviewService.ConsultarDados();

    if (!this.acesso.cartaoId) {
      this.snackService.SnackMessage('Cartão inválido');
      return this.router.navigate(['/auth/login']);
    }

    if (!this.acesso.scopes || this.acesso.scopes.length == 0) {
      this.snackService.SnackMessage('Acesso inválido');
      return this.router.navigate(['/auth/login']);
    }

    if (this.acesso.scopes.indexOf('write_cartao') >= 0) {
      this.viewEdit = true;
    }
  }

  async initCartao() {
    this.cartao = await this.webviewService.LerUmCartao(this.acesso.cartaoId)

    if (!this.cartao.paciente || !this.cartao.id) {
      this.snackService.SnackMessage('Cartão inválido');
      return this.router.navigate(['/auth/login']);
    }

    if (this.acesso.pacienteId !== this.cartao.paciente) {
      this.snackService.SnackMessage('Acesso cartão não pertence ao paciente');
      return this.router.navigate(['/auth/login']);
    }

    // Atualizando os formulários 
    const aux1 = {
      data_concepcao: this.TimeStampToDate(this.cartao.data_concepcao),
      previsao_parto_dum: this.TimeStampToDate(this.cartao.previsao_parto_dum),
      previsao_parto_ultrassom: this.TimeStampToDate(this.cartao.previsao_parto_ultrassom)
    };

    this.form_info_cartao.setValue(aux1);
    this.formulario_cartao_gestante = this.componente_cartao_gestante.cartao_gestante;

    this.setFormValue(this.formulario_cartao_gestante.controls.historico_clinico, this.cartao.historico_clinico);
    this.setFormValue(this.formulario_cartao_gestante.controls.historico_familiar, this.cartao.historico_familiar);
    this.setFormValue(this.formulario_cartao_gestante.controls.antecedentes_obstetricos, this.cartao.antecedentes_obstetricos);
    this.setFormValue(this.formulario_cartao_gestante.controls.sobre_a_gestacao, this.cartao.sobre_a_gestacao);
    this.setFormValue(this.formulario_cartao_gestante.controls.vacinas, this.cartao.vacinas);

    if (this.cartao.exames.hasOwnProperty('clinicos')) {
      this.dados_graficos_prontos = true;
      this.dados_dos_graficos = this.cartao.exames.clinicos;
    }

    // Tentando forçar a atualização
    this.componente_cartao_gestante.cartao_gestante_obj = this.cartao;

    this.events.publish('CartaoGestanteDataLoad');

    this.formulario_cartao_alterado = false;

    this.formulario_cartao_gestante.valueChanges.subscribe(res => {

      this.formulario_cartao_alterado = true;

      const formValue = this.formulario_cartao_gestante.value;

      this.cartao.sobre_a_gestacao = formValue.sobre_a_gestacao;
      this.cartao.historico_clinico = formValue.historico_clinico;
      this.cartao.historico_familiar = formValue.historico_familiar;

    });

    if (this.viewEdit && this.cartao.encerrado) this.viewEdit = false;

  }

  async initSessao() {
    if (!this.cartao || !this.cartao.paciente) {
      this.snackService.SnackMessage('Cartão inválido');
      return this.router.navigate(['/auth/login']);
    }

    this.paciente = await this.webviewService.GetPacientePorId(this.cartao.paciente)

    if (this.acesso.userId === this.acesso.pacienteId) {

      this.usuarioLogado = this.paciente;

    } else if (this.cartao.medico) {

      const profissional = await this.webviewService.GetInfoProfissional(this.cartao.medico)

      if (profissional.tipo_usuario == 'medico') this.profissional = profissional as Medico;
      if (profissional.tipo_usuario == 'enfermeiro') this.profissional = profissional as Enfermeiro;

    }
  }

  async initData(): Promise<void> {
    try {
      logger.log('[WebviewCartao] Iniciando carregamento de dados...');
      
      await this.initMenu();
      logger.log('[WebviewCartao] Menu inicializado');
      
      await this.initAcesso();
      logger.log('[WebviewCartao] Acesso validado');
      
      await this.initCartao();
      logger.log('[WebviewCartao] Cartão carregado');
      
      await this.initSessao();
      logger.log('[WebviewCartao] Sessão inicializada');
      
      this.loading = false;
      this.showCard = true;

      // Verificar se o parâmetro 'print' está presente na URL
      this.activatedRoute.queryParams.subscribe(params => {
        if (params['print'] === 'true' || params['print'] === '1') {
          // Aguardar um pequeno delay para garantir que a página foi renderizada
          setTimeout(() => {
            this.Imprimir();
          }, 500);
        }
      });
      
    } catch (error) {
      logger.error('[WebviewCartao] Erro ao carregar dados:', error);
      this.loading = false;
      
      let errorMessage = 'Erro ao carregar informações do cartão';
      if (error && error.status === 401) {
        errorMessage = 'Sessão expirada. Solicite um novo link.';
      } else if (error && error.status === 403) {
        errorMessage = 'Você não tem permissão para visualizar este cartão.';
      } else if (error && error.status === 404) {
        errorMessage = 'Cartão não encontrado.';
      } else if (error && error.message) {
        errorMessage = error.message;
      }
      
      this.snackService.SnackMessage(errorMessage);
      
      // Aguarda um pouco antes de redirecionar para dar tempo do usuário ler a mensagem
      setTimeout(() => {
        this.router.navigate(['/auth/login']);
      }, 3000);
    }
  }

  AddModalExame() {

    const dialogRef = this.matDialog.open(ModalAdicionarExameComponent, {
      width: '300px'
    });

    dialogRef.afterClosed().subscribe((res) => {
      
      this.addModalExameOnload(res);

    });
  }

  addModalExameOnload(res) {

    switch (res) {
      case 'clinico':
          this.InserirClinico();
          break;
      case 'laboratorial':
          this.InserirLab();
          break;
      case 'ultrassom':
          this.InserirUSG();
          break;
      case 'outro':
          this.InserirOutro();
          break;
      default:
          break;
    }

  }

  /** @todo IMPLEMENTAR O MODAL QUE IRÁ ALTERAR O VALOR  */
  SubindoEdicaoCelularExames(event) {

    const trimestre_clicado = event.trimestre;

    if (event.exame == null && event.anotherField == 'data') { // Edição de data

      const dataTrimestre = this.cartao.exames.laboratorio[0].datas[`data${trimestre_clicado}`];

      this.modalService.AbrirModalDataTrimestre(dataTrimestre).subscribe((res: any) => {

        if (res == null || res == undefined) { return; }

        const aux = res ? res : '';

        this._apigestacard.AlterarTrimestreExameLab(this.cartao.id, trimestre_clicado, aux, this.cartao.exames).then((result) => {

          this.cartao.exames.laboratorio = result;

          this.events.publish('ChangeDataTrimestre');

          this.snackService.SnackMessage('Data do trimestre alterada!');

        }).catch((err) => {

          logger.log('WebviewCartaoGestanteComponent -> AlterarTrimestreExameLab -> err', err);

        });

      });

    } else {

      const data_limite_aux = event.exame[`data_limite_tri${trimestre_clicado}`];
      const data_limite: Date = !data_limite_aux || data_limite_aux == '' ? null : new Date(data_limite_aux.seconds * 1000);
      const hoje = new Date();

      const oldValue = event.exame.datas[`res${trimestre_clicado}`];

      // ** FUNCAO DE CHECAGEM DE DATA LIMITE DESABILITADA
      this.modalService.AbrirModalResultadoExame(event.exame.name, oldValue).subscribe((res: any) => {
        const aux = res ? res : '';

        this._apigestacard.AlterarValorExameLab(this.cartao.id, event.trimestre, event.allTrimestre, aux, event.exame, this.cartao.exames).then((result) => {

        }).catch((err) => {

          logger.log('WebviewCartaoGestanteComponent -> SubindoEdicaoCelularExames -> err', err);

        });

      });

    }

  }

  EncerrarCartao() {

    const dialogEncerrar = this.matDialog.open(WebviewEncerrarCartaoComponent, { 
      maxWidth: '80%',
      data: { 
        paciente: this.paciente, 
        cartao: this.cartao
      }
    });

    dialogEncerrar.afterClosed().subscribe((formData?) => {

      if (formData !== undefined) {

        this.webviewService.RegistrarEncerramento(this.cartao.id, formData).finally(() => {

          this.snackService.SnackMessage('Cartão encerrado com sucesso!');
          this.BuscarDadosCartao();

        });

      }

    });

  }

  RecarregarPaginaDoCartao() {

    this.router.navigate(['/webview'], { queryParamsHandling: 'preserve' });

  }

  InserirClinico() {

    const sobre_a_gestacao = this.cartao.sobre_a_gestacao;

    this.cartaoService.AbrirModalClinicos(sobre_a_gestacao.dum, sobre_a_gestacao.us1, sobre_a_gestacao.us_semanas, sobre_a_gestacao.us_dias).subscribe((res) => {

        if (res) {

          this._apigestacard.InserirExameClinico(this.cartao.id, res, this.cartao.exames).then((result) => {

            this.InserirExameRefresh();
            
          }).catch((err) => {

              logger.log('WebviewCartaoGestanteComponent -> InserirClinico -> err', err);

          });

        }

    });
  }

  /**
   * 
   * @param data Valores atuais do exame clinico que serão modificados
   */
  EditarClinico(data) {

    const sobre_a_gestacao = data;
    
    this.cartaoService.AbrirModalClinicosEditar(data).subscribe((res) => {
      
      if (res) {
        this._apigestacard.EditarExameClinico(this.cartao.id, data, res, this.cartao.exames).then((result) => {
          
          this.InserirExameRefresh();

        }).catch((err) => {

          logger.log('WebviewCartaoGestanteComponent -> InserirClinico -> err', err);
            
        });
      }
    });

  }
  
  ExameClinicoAddObservacao(data) {

    this.cartaoService.AbrirModalClinicosEditarObservacao(data).subscribe((res) => {
      
      if (res) {
        let newData = data;
        
        newData.obs = res.obs; // Atualizando a observação do exame clinico com a nova observação adicionada

        this._apigestacard.EditarExameClinico(this.cartao.id, data, newData, this.cartao.exames).then((result) => {
          
          this.InserirExameRefresh();

        }).catch((err) => {

          logger.log('WebviewAlterarCartaoGestanteComponent -> InserirClinico -> err', err);
            
        });
      }

    });

  }
  
  async AnalisarPDFExamesLab(data: { callback: (exames: ExameLaboratorio[]) => void }) {    
    try {
      let dum, cartao_id, exames_lab;
      
      if (this.cartao.sobre_a_gestacao && this.cartao.sobre_a_gestacao.dum) dum = this.cartao.sobre_a_gestacao.dum;
      if (this.cartao.id) cartao_id = this.cartao.id;
      if (this.cartao.exames.laboratorio) exames_lab = this.cartao.exames.laboratorio;

      if (!dum || !cartao_id || !exames_lab) {
        logger.error('Dados insuficientes para analisar PDF de exames laboratoriais.');
        return;
      }

      const result = await this.modalService.AnalisarExamesPorPDF(exames_lab, dum, cartao_id);
      
      if (!result) return;

      data.callback(result.examesLaboratorios);
      
      this.formulario_cartao_alterado = true;
      this.AtualizarExamesLab({ examesNew: result.examesLaboratorios });

      this.webviewService.MudarStatusArquivo(result.arquivoId, 'utilizado');

      return result.examesLaboratorios;
    } catch (error) {
      logger.error('Erro ao analisar PDF de exames:', error);
    }
  }

  async UtilizarArquivoLabExistente(data: { arquivoId: string, trimestre: number, callback: (exames: ExameLaboratorio[]) => void, onFinish?: () => void }) {
    return this.processarArquivoLabExistente(data, false);
  }

  async AnalisarArquivoLabExistente(data: { arquivoId: string, trimestre: number, callback: (exames: ExameLaboratorio[]) => void, onFinish?: () => void }) {
    return this.processarArquivoLabExistente(data, true);
  }

  private async processarArquivoLabExistente(
    data: { arquivoId: string, trimestre: number, callback: (exames: ExameLaboratorio[]) => void, onFinish?: () => void },
    reanalisar: boolean
  ) {
    try {
      const exames_lab = this.cartao.exames.laboratorio;
      const dum = this.cartao.sobre_a_gestacao && this.cartao.sobre_a_gestacao.dum
        ? this.cartao.sobre_a_gestacao.dum
        : undefined;
      const cartao_id = this.cartao.id;

      const result = await this._laboratorioArquivoFlow.processarArquivoExistente({
        arquivoId: data.arquivoId,
        trimestre: data.trimestre,
        examesLab: exames_lab,
        dum,
        cartaoId: cartao_id,
        reanalisar
      });

      if (!result) { data.onFinish && data.onFinish(); return; }

      data.callback(result.examesLaboratorios);
      this.formulario_cartao_alterado = true;
      this.AtualizarExamesLab({ examesNew: result.examesLaboratorios });

      if (this.cartao.arquivos_analisados) {
        const arq = this.cartao.arquivos_analisados.find(a => a.id === data.arquivoId);
        if (arq) arq.status = 'utilizado';
      }

      data.onFinish && data.onFinish();
      this.webviewService.MudarStatusArquivo(data.arquivoId, 'utilizado');
    } catch (error) {
      logger.error(
        reanalisar
          ? 'Erro ao analisar arquivo laboratorial existente:'
          : 'Erro ao utilizar arquivo laboratorial existente:',
        error
      );
      data.onFinish && data.onFinish();
    }
  }

  async AlterarListaUSG() {
    if (!this.cartao || !this.cartao.id) return;

    const result = await this.modalService.AnalisarUltrasonografiaPorPDF(this.cartao.exames.ultrasom, this.cartao.id);
    
    if (!result) return;

    this.formulario_cartao_alterado = true;
    this.cartao.exames.ultrasom = result.ultrasonografias;

    this._apigestacard.AlterarUSG(this.cartao.id, result.ultrasonografias, this.cartao.exames).then(() => {
      this.InserirExameRefresh();

      this.webviewService.MudarStatusArquivo(result.arquivoId, 'utilizado');
    }).catch((err) => {
      logger.log('MedicoAlterarCartaoGestanteComponent -> AlterarListaUSG -> err', err);
    });
  }

  InserirLab() {

    this.cartaoService.AbrirModalLab(this.cartao.exames.laboratorio).subscribe((res) => {
      
      if (res) {
        const vetor_exames = res.exames_selecionados.map((item) => {
          return {
            name: item,
            data_limite_tri1: res.trimestre == 1 ? res.data_limite_edicao : '',
            data_limite_tri2: res.trimestre == 2 ? res.data_limite_edicao : '',
            data_limite_tri3: res.trimestre == 3 ? res.data_limite_edicao : '',
            datas: {
                data1: res.trimestre == '1' ? res.data : '',
                data2: res.trimestre == '2' ? res.data : '',
                data3: res.trimestre == '3' ? res.data : '',
                res1: '',
                res2: '',
                res3: '',
            }
          };
        });

        this._apigestacard.InserirLab(this.cartao.id, vetor_exames, this.cartao.exames).then((result) => {
          
          this.InserirExameRefresh();

        }).catch((err) => {

          logger.log('WebviewCartaoGestanteComponent -> InserirLab -> err', err);

        });

      }

    });

  }

  RemoverExameLab(event) {

    const exame = event.exame;

    this.modalService.AbrirModalDeConfirmacao('Remover Exame Laboratorial', `Tem certeza que deseja remover o exame ${exame.name}? Essa ação não poderá ser desfeita.`).subscribe((res) => {
      if (res) {
        this._apigestacard.RemoverExameLaboratorios(this.cartao.id, exame, this.cartao.exames).then((result) => {
          this.cartao.exames = result;
        }).catch((err) => {
          logger.log('MedicoAlterarCartaoGestanteComponent -> RemoverExameLab -> err', err);
        });
      }
    });
    
  }

  RemoverExameUSG(event: { exame: any, callback?: (ultrasom: any[]) => void }) {
    const exame = event.exame;

    this.modalService.AbrirModalDeConfirmacao('Remover Ultrassonografia', 'Tem certeza que deseja remover esta ultrassonografia? Essa ação não poderá ser desfeita.').subscribe((res) => {
      if (!res) return;

      const ultrasomAtual = this.cartao.exames.ultrasom || [];
      const ultrasomAtualizado = ultrasomAtual.filter(item => item !== exame);

      this._apigestacard.AlterarUSG(this.cartao.id, ultrasomAtualizado, this.cartao.exames).then((result) => {
        this.cartao.exames = result;
        if (event.callback) event.callback(result.ultrasom || []);
        this.InserirExameRefresh();
      }).catch((err) => {
        logger.log('WebviewCartaoGestanteComponent -> RemoverExameUSG -> err', err);
      });
    });
  }

  InserirUSG() {

    this.cartaoService.AbrirModalUSG().subscribe((res) => {

      if (res) {
        
        this._apigestacard.InserirUSG(this.cartao.id, res, this.cartao.exames).then(() => {
          
            this.InserirExameRefresh();

        }).catch((err) => {

            logger.log('WebviewCartaoGestanteComponent -> InserirUSG -> err', err);

        });

      }

    });

  }

  async UtilizarArquivoUSGExistente(data: { arquivoId: string, callback: (ultrasom: any[]) => void, onFinish?: () => void }) {
    try {
      const arquivo = await this._apigestacard.BuscarArquivoPDF(data.arquivoId);
      if (!arquivo) {
        logger.error('Arquivo USG não encontrado.');
        data.onFinish && data.onFinish();
        return;
      }

      let preAnalisedUSG: any[];
      if (arquivo.status === 'pendente') {
        logger.error('Arquivo USG pendente precisa ser analisado antes de utilizar.');
        data.onFinish && data.onFinish();
        return;
      }

      if (!arquivo.resultado) {
        logger.error('Arquivo USG sem resultado.');
        data.onFinish && data.onFinish();
        return;
      }

      preAnalisedUSG = Array.isArray(arquivo.resultado) ? arquivo.resultado : [arquivo.resultado];

      const result = await this.modalService.UtilizarArquivoAnalisadoUSG(
        data.arquivoId,
        preAnalisedUSG,
        this.cartao.exames.ultrasom,
        this.cartao.id
      );

      if (!result) { data.onFinish && data.onFinish(); return; }

      this.formulario_cartao_alterado = true;
      this.cartao.exames.ultrasom = result.ultrasonografias;

      if (this.cartao.arquivos_analisados) {
        const arq = this.cartao.arquivos_analisados.find(a => a.id === data.arquivoId);
        if (arq) arq.status = 'utilizado';
      }

      data.onFinish && data.onFinish();
      this._apigestacard.AlterarUSG(this.cartao.id, result.ultrasonografias, this.cartao.exames).then(() => {
        this.InserirExameRefresh();
        data.callback(result.ultrasonografias);
        this.webviewService.MudarStatusArquivo(data.arquivoId, 'utilizado');
      }).catch(err => logger.log('UtilizarArquivoUSGExistente -> err', err));
    } catch (error) {
      logger.error('Erro ao utilizar arquivo USG existente:', error);
      data.onFinish && data.onFinish();
    }
  }

  async AnalisarArquivoUSGExistente(data: { arquivoId: string, callback: (ultrasom: any[]) => void, onFinish?: () => void }) {
    try {
      const arquivo = await this._apigestacard.BuscarArquivoPDF(data.arquivoId);
      if (!arquivo) {
        logger.error('Arquivo USG não encontrado.');
        data.onFinish && data.onFinish();
        return;
      }

      const reanalise = await this._apigestacard.ReAnalisarUltrasom(data.arquivoId);
      const result = await this.modalService.UtilizarArquivoAnalisadoUSG(
        data.arquivoId,
        reanalise.ultrasonografias,
        this.cartao.exames.ultrasom,
        this.cartao.id
      );

      if (!result) { data.onFinish && data.onFinish(); return; }

      this.formulario_cartao_alterado = true;
      this.cartao.exames.ultrasom = result.ultrasonografias;

      if (this.cartao.arquivos_analisados) {
        const arq = this.cartao.arquivos_analisados.find(a => a.id === data.arquivoId);
        if (arq) arq.status = 'utilizado';
      }

      data.onFinish && data.onFinish();
      this._apigestacard.AlterarUSG(this.cartao.id, result.ultrasonografias, this.cartao.exames).then(() => {
        this.InserirExameRefresh();
        data.callback(result.ultrasonografias);
        this.webviewService.MudarStatusArquivo(data.arquivoId, 'utilizado');
      }).catch(err => logger.log('AnalisarArquivoUSGExistente -> err', err));
    } catch (error) {
      logger.error('Erro ao analisar arquivo USG existente:', error);
      data.onFinish && data.onFinish();
    }
  }

  InserirOutro() {

    this.cartaoService.AbrirModalOutros().subscribe((res) => {

      if (res) {

        this._apigestacard.InserirOutros(this.cartao.id, res, this.cartao.exames).then((result) => {
          
          this.InserirExameRefresh();

        }).catch((err) => {

          logger.log('WebviewCartaoGestanteComponent -> InserirOutro -> err', err);
          
        });

      }

    });

  }

  InserirExameRefresh() {
    
    if (this.formulario_cartao_alterado) {
      
      this.SalvarAlteracoes(() => {
        
        this.BuscarDadosCartao();

      });

    } else {
      
      this.BuscarDadosCartao();

    }

  }

  BuscarDadosCartao() {
    
    this.loading = true;
    this.dados_dos_graficos = [];

    this.webviewService.LerUmCartao(this.cartao.id).then((res) => {
      this.cartao = res;

      // Atualizando os formulários 
      const aux1 = {
        data_concepcao: this.TimeStampToDate(this.cartao.data_concepcao),
        previsao_parto_dum: this.TimeStampToDate(this.cartao.previsao_parto_dum),
        previsao_parto_ultrassom: this.TimeStampToDate(this.cartao.previsao_parto_ultrassom)
      };

      this.form_info_cartao.setValue(aux1);

      this.setFormValue(this.formulario_cartao_gestante.controls.historico_clinico, this.cartao.historico_clinico);
      this.setFormValue(this.formulario_cartao_gestante.controls.historico_familiar, this.cartao.historico_familiar);

      this.setFormValue(this.formulario_cartao_gestante.controls.antecedentes_obstetricos, this.cartao.antecedentes_obstetricos);
      this.setFormValue(this.formulario_cartao_gestante.controls.sobre_a_gestacao, this.cartao.sobre_a_gestacao);
      this.setFormValue(this.formulario_cartao_gestante.controls.vacinas, this.cartao.vacinas);

      if (this.cartao.exames.hasOwnProperty('clinicos')) {
        this.dados_graficos_prontos = true;
        this.dados_dos_graficos = this.cartao.exames.clinicos;
      }

      // Tentando forçar a atualização
      this.componente_cartao_gestante.cartao = this.cartao;

      this.events.publish('CartaoGestanteDataLoad');

      this.formulario_cartao_alterado = false;

      this.formulario_cartao_gestante.valueChanges.subscribe(res => {

        this.formulario_cartao_alterado = true;

        const formValue = this.formulario_cartao_gestante.value;

        this.cartao.sobre_a_gestacao = formValue.sobre_a_gestacao;
        this.cartao.historico_clinico = formValue.historico_clinico;
        this.cartao.historico_familiar = formValue.historico_familiar;

      });

    }).catch((err) => {

      this.loading = false;

      this.snackService.SnackMessage('Cartão indisponivel para alteração');

    }).finally(() => {
        this.loading = false;
        this.showCard = true;

    });

  }

  /**
   * Seta o form value a partir do novo layout do form, para nao dar erro com mudanças de estrutura no firebase
   * @param form 
   * @param obj 
   */

  setFormValue(form, obj) {

      const layout = form.value;
      
      for (const z in layout) {
          if (obj.hasOwnProperty(z)) { layout[z] = obj[z]; }
      }

      form.patchValue(layout);

  }

  TimeStampToDate(obj): Date {
      const date = new Date(obj.seconds * 1000);
      return date;
  }

  SalvarAlteracoes(callback?: () => any) {

    const cartao_gestante = this.formulario_cartao_gestante.value;
    const cartao_atualizado = { ...cartao_gestante };

    this.webviewService.AtualizarCartao(this.cartao.id, cartao_atualizado).then(() => {

      this.snackService.SnackMessage('Cartão atualizado com sucesso!');
      
      if (callback) callback()

    }).catch((err) => {

      this.snackService.SnackMessage('Erro ao atualizar o cartão');

    });

  }

  get dataCriacao() {

    if (!this.cartao.criado_em) return ''

    const data = new Date(this.cartao.criado_em);
    return data;

  }


  imprimindoPDF = false;

  async Imprimir() {
    this.imprimindoPDF = true;
    try {
      const result = await this._apigestacard.GerarPDF(this.cartao.id);
      window.open(result.url, '_system');
    } catch (err) {
      logger.log('WebviewCartaoGestanteComponent -> Imprimir -> err', err);
    } finally {
      this.imprimindoPDF = false;
    }
  }

  AtualizarExamesLab(event) {
    this.cartao.exames.laboratorio = event.examesNew;
    
    this.formulario_cartao_alterado = true;
  }

  async AbrirArquivoAnalisado(arquivo_id: string): Promise<void> {
    try {
      const arquivo = await this._apigestacard.BuscarArquivoPDF(arquivo_id);
      window.open(arquivo.blob_url, '_system');
    } catch (error) {
      logger.error('Erro ao buscar PDF:', error);
    }
  }

  CartaoFoiAlterado() {
    this.formulario_cartao_alterado = true;
  }
}
